import styled from 'styled-components';

const Options = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  
  
`;

export default Options;
